// Only send fixed event names and placements. Never send URLs, messages or patient data.
export function installContactTracking(doc = document, win = window) {
  win.dataLayer = win.dataLayer || [];
  const handleClick = (event) => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button > 0) return;
    const href = link.getAttribute('href');
    const phone = /^tel:/i.test(href);
    const whatsapp = /^https:\/\/wa\.me\//i.test(href);
    if (!phone && !whatsapp) return;
    const placement = link.classList.contains('floating-whatsapp') ? 'floating_button'
      : link.classList.contains('floating-call') ? 'floating_call_button'
      : link.classList.contains('mobile-call-bar') ? 'mobile_call_bar'
      : link.closest('#home') ? 'hero'
      : link.closest('#about') ? 'about'
      : link.closest('#contact') ? 'contact_section'
      : link.closest('footer') ? 'footer' : 'other';
    win.dataLayer.push({ event: phone ? 'phone_click' : 'whatsapp_click', contact_placement: placement });
  };
  doc.addEventListener('click', handleClick);
  return () => doc.removeEventListener('click', handleClick);
}

export function loadTagManager(id, doc = document, win = window) {
  if (!id) return;
  if (!/^GTM-[A-Z0-9]+$/.test(id)) throw new Error('Invalid Google Tag Manager container ID');
  if (doc.getElementById('practice-gtm')) return;
  win.dataLayer = win.dataLayer || [];
  win.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const script = doc.createElement('script');
  script.id = 'practice-gtm';
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtm.js?id=' + id;
  doc.head.appendChild(script);
}
